import * as actiontypes from './actionTypes';
import MerchZoneApi from '../api/merchZoneApi';

export function merchZoneLoading() {
    return { type: actiontypes.MERCHZONE_LOADING };
}

export function merchZoneError() {
    return { type: actiontypes.MERCHZONE_ERROR };
}

export function merchZone(response) {
    return { type: actiontypes.MERCHZONE_SUCCESS, response };
}

export function getMerchZone(merchZoneId) {
    return function (dispatch) {
        dispatch(merchZoneLoading());
        let requestUrl = "MerchZone/" + merchZoneId;
        return MerchZoneApi.getMerchZone(requestUrl).then(response => {
            dispatch(merchZone(response));
        }).catch(error => {
            dispatch(merchZoneError());
            throw error;
        });
    };
}